export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/om8wVddcfpZ7jRkExKvHNy/Mock_up_BIR.png'
